import React from "react";
import { Dashboard, SettingDashboardPage } from "./../WrapperLazyExport";

import { SETTING_DASHBOARD } from "App/constants";
import { DASHBOARD } from "App/constants";

export const menuDashboard = {
  [SETTING_DASHBOARD]: <SettingDashboardPage />,
  [DASHBOARD]: <Dashboard />,
};
